<template>
	<transition name='ts'>
		<div class="today-statistics-wrapper" v-if="list.length > 0">
			<div class="modal" v-for="li in list">
				<span>{{li.label}}</span><span class="orange">{{li.value}}</span>
			</div>
		</div>
	</transition>
</template>
<script>
export default {
	props: {
		db: {
			type: Array,
			default () {
				return [];
			}
		}
	},
	data() {
		return {
			list: [{
				label: '加载中...',
				value: '0'
			}]
		}
	},
	mounted() {
		this.list = JSON.parse(JSON.stringify(this.$props.db));
	},
	watch: {
		db(val,oldVal) {
			if(JSON.stringify(val) != JSON.stringify(oldVal)) {
				this.list = []
				this.reloadData();
			}
		}
	},
	methods: {
		reloadData() {
			clearTimeout(this.popTimeout);
			this.popTimeout = setTimeout(() => {
				this.list = JSON.parse(JSON.stringify(this.$props.db));
				clearTimeout(this.popTimeout);
			}, 500);
		}
	}
}

</script>
<style scoped>
	.modal{
		float: left;
		width: 24.9%;
		text-align: center;
		line-height: 69px;
		font-weight: bold;
		font-size: 18px;
	}
	.orange {
		color: #ffc600;
		margin-left: 8px;
		display: inline-block;
	}
	
	.ts-enter,.ts-leave-to,.ts-enter-active,.ts-leave-active {
		transition: .5s
	}
	.ts-enter .orange,.ts-leave-to .orange {
		transform: scaleY(0);
		opacity: 0;
		transition: .5s
	}
	.ts-enter-active .orange,.ts-leave-active .orange {
		transition: .5s
	}
</style>



// WEBPACK FOOTER //
// src/components/charts/TodayStatistics.vue